import { render, staticRenderFns } from "./BuildingInfo.vue?vue&type=template&id=132e0c74&scoped=true&"
import script from "./BuildingInfo.vue?vue&type=script&lang=js&"
export * from "./BuildingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuildingInfo.vue?vue&type=style&index=0&id=132e0c74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e0c74",
  null
  
)

export default component.exports